// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0vjhT35fFJg2DGsoqKCHFadBZvPUxfRk",
  authDomain: "questown-5cc5d.firebaseapp.com",
  projectId: "questown-5cc5d",
  storageBucket: "questown-5cc5d.firebasestorage.app",
  messagingSenderId: "320263781220",
  appId: "1:320263781220:web:a0a7d4a11e44ea4cb59871",
  measurementId: "G-0MBWPSZDBY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export { analytics, logEvent };


